import React, { FC } from 'react'
import { graphql, useFragment } from 'react-relay'

import { Metadata } from '../Metadata'

import { UserMetadata_user$key } from './__generated__/UserMetadata_user.graphql'

export const UserMetadata: FC<{
  user: UserMetadata_user$key
  title?: string
  description?: string
}> = ({ user, title, description }) => {
  const { bio, firstName, lastName, primaryPhoto } = useFragment(
    graphql`
      fragment UserMetadata_user on User {
        firstName
        lastName
        bio
        primaryPhoto {
          url
        }
      }
    `,
    user
  )

  const name = `${firstName} ${lastName}`

  return (
    <Metadata
      title={title || name}
      description={description || bio}
      photoUrl={primaryPhoto?.url}
    />
  )
}
